import ButtonResetChat from "./ButtonResetChat";
import { Props } from "./types";

function TopBarIFrame(props: Props) {
  const {
    botInfo,
    resetChat,
    startAgainLabel,
    setIsResetChatModalOpen,
    messagesLength,
  } = props;

  return (
    <div className="flex items-start gap-4 self-stretch border-x-0 border-b border-t-0 border-solid border-supporting-divider bg-white p-4">
      <div className="flex flex-1 justify-between gap-4">
        <div className="flex gap-3">
          <img
            className="h-9 w-9"
            alt="Company logo"
            src={botInfo.bot_info_config.company_logo}
          />
          <div className="flex flex-col">
            <p className="font-semibold leading-6">
              {botInfo.bot_info_config.company_name}
            </p>
            <p className="text-sm leading-4 text-secondary">
              {botInfo.bot_info_config.chatbot_subheading}
            </p>
          </div>
        </div>
        <div className="flex">
          {!!messagesLength && (
            <ButtonResetChat
              botInfo={botInfo}
              resetChat={resetChat}
              setIsResetChatModalOpen={setIsResetChatModalOpen}
              startAgainLabel={startAgainLabel}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default TopBarIFrame;
